import Track from 'akubt';
Track.setEnv (process.env.VUE_APP_ENV !== 'production' ? 'dev' : '');

export default Track;
